import angular from 'angular';

class controlCreateDoModalCtrl {
  /* @ngInject */
  constructor() {}

  $onInit() {
    this.modalTitle = angular.copy(this.resolve.modalTitle);
    this.modalMessage = angular.copy(this.resolve.modalMessage);
    this.modalCancelButtonText = angular.copy(this.resolve.modalCancelButtonText);
    this.modalConfirmButtonText = angular.copy(this.resolve.modalConfirmButtonText);
  }

  mapProfilDo(profil) {
    switch (profil) {
      case 'SENDER':
        return 'SELLER';
      case 'RECEIVER':
        return 'BUYER';
      case 'TWO_WAY_DEMAT':
        return 'BUYER_SELLER';
    }
  }

  cancel() {
    this.modalInstance.dismiss();
  }

  dismiss() {
    this.modalInstance.close();
  }
}

angular.module('app.principal').component('controlCreateDoModal', {
  templateUrl: require('./modal-control-create-do.html'),
  controller: controlCreateDoModalCtrl,
  bindings: {
    modalInstance: '<',
    resolve: '<'
  }
});
